var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    borders = _ref.borders;
  return {
    mainContainerBackground: colors.porcelain,
    mainContainerMargin: spacing.xSmall,
    mainContainerPadding: spacing.xSmall,
    bodyBackground: colors.white,
    bodyPadding: spacing.xSmall,
    bodyMargin: spacing.xSmall,
    bodyBorderRadius: borders.radiusMedium,
    feedbackWrapperMargin: spacing.xSmall,
    feedbackWrapperPadding: spacing.xSmall,
    unansweredMargin: spacing.xSmall,
    userResponseBackground: colors.white,
    userResponsePadding: spacing.xSmall,
    noChoicesMargin: spacing.xSmall,
    categoryBodyBorderColor: colors.tiara,
    categoryBodyBorderWidth: borders.radiusSmall
  };
};
export default generateComponentTheme;